import { Table } from 'antd';
import { FC, useMemo } from 'react';

import { SitesArchive } from '../../../entities';
import { SiteArchivesListTableDataObj } from '../../../sites.interfaces';
import { columns } from './columns';

interface Props {
  archivesList: SitesArchive[];
}

export const SitesArchivesListView: FC<Props> = ({ archivesList }) => {
  const dataSource = useMemo<SiteArchivesListTableDataObj[]>(() => {
    return archivesList?.map((archive: SitesArchive, idx: number) => ({
      id: archive.id,
      key: idx,
      name: archive.file.name,
      createdAt: archive.createdAt,
      processedAt: archive.processedAt,
      filesCount: archive.filesCount,
      pagesCount: archive.pagesCount,
      size: archive.file.formattedSize,
      status: archive.status,
      downloadLink: archive.file.url,
      errorMessage: archive.errorMessage
    })) ?? [];
  }, [archivesList]);

  return <Table pagination={ false } columns={ columns() } dataSource={ dataSource }/>;
};
